export default __webpack_public_path__ + "static/experienceBg-0ec4fe715fe5e44e6d16e036eb62348b.png";